/*

ashraf 10/16/2022  2700614626  added code comments in search, add user management.
ashraf 10/27/2022  2700614626  user management ux changes
ashraf 10/28/2022  2700614626  removed the cardstyling classname
ashraf 10/30/2022 2700614626 conditional tabs render
Rohini 10/30/2022 2700614626 added classname for the tab section
Suresh Peddavoora 12/05/2022 2700614626 Modified Landing Page Format.
Ashraf 12/05/2022 2700614626 Fixed header labels
Prakash 12/22/2022 2700614626 Add card Styling.
*/

import React, {useContext} from 'react';
import Tabs from './Tabs';
import LandingPage from '../LandingPage';
import {ThemeContext} from '../../themes/ThemeProvider';

// initial component render (2700614626)
function UserManagement() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [mainTabValue, setMainTabValue] = React.useState(0);
  const tabs = ['User Management'];

  // handles tab change (2700614626)
  const handleChange = (event, newValue) => {
    setMainTabValue(newValue);
  };

  return (
    <>
      <LandingPage title={'Administration'} allAntTabs={tabs} showTabs={true} tabValue={mainTabValue} handleTabChange={handleChange}>
        <div className="global-field-dash-board">
          <div className={classes.cardStyleWhite}>
            <div>
              {mainTabValue === 0 && <Tabs />}
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default UserManagement;
